export const CLOSING_TIMEOUT_MS = 300;
export const CLOSING_TIMEOUT_OFFSET_MS = 30;
